import { PaneContentType, PaneType } from "../types";

export function isUserOnStage(panes: PaneType[], userId: string) {
  return !!panes.find(
    (pane) => pane.content_id === userId && pane.content_type === PaneContentType.User,
  );
}

export function getPaneIndexForUser(panes: PaneType[], userId: string) {
  return panes.findIndex(
    (pane) => pane.content_id === userId && pane.content_type === PaneContentType.User,
  );
}

export function getEmptyPaneIndex(panes: PaneType[]) {
  return panes.findIndex((pane, index) => {
    if (index === 0 && panes.length % 2 === 1) {
      return false;
    }
    return pane.content_type === PaneContentType.Empty;
  });
}
